import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { AngularFirestore } from '@angular/fire/firestore';
import { Subscription } from 'rxjs';
import { Totalizadores, ITotalizador } from '../../../../models/totalizadores.model';
import { DataModelComponent } from '../../../../models/data.model.component';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { MaterialIcons } from '../../../../comum/services/icons.service';



@Component({
  selector: 'app-totalizadores',
  templateUrl: './totalizadores.component.html',
  styleUrls: ['./totalizadores.component.scss']
})
export class TotalizadoresComponent extends DataModelComponent<ITotalizador> implements OnInit, OnDestroy {
  dataSource: Array<any> = [];
  dataClass: Totalizadores;
  dataEvent: Subscription;
  icons:string[]=[];
  @ViewChild('grid') grid: MatDataGridComponent;
  colunas = [
  { field: "icon", text:"icon", type:"icon"},
  { field:"ordem", text:"Ordem", },
  { field: "titulo", text: "Título" },
  { field: "valor", text: "Valor" },
  { field: "dashboard", text: "Dash" }
  ];

  constructor(private db: AngularFirestore,
    private iconsService:MaterialIcons) {
    super({
      ordem: new FormControl(),
      titulo: new FormControl(),
      count: new FormControl(),
      icon: new FormControl(),
      dashboard: new FormControl(),
      inativo: new FormControl(),
      anunciante: new FormControl(0),
    });
    this.icons = this.iconsService.getIcons();
    this.dataClass = new Totalizadores(db);
  }

  ngOnInit() {
    this.dataEvent = this.dataClass.changedEvent.subscribe(
      d => {
        this.dataSource = d;
      });
    this.dataClass.verInativo = false;
  }

  ngOnDestroy() {
    this.dataEvent.unsubscribe();
  }

  doPostItem(event) {
    this.dataClass.post(this.item);
    super.doPostItem(event);
  }

  getFilterAttrib() {
    return 'ver inativos';
  }

  doCheckFilter(x: boolean) {
    this.dataClass.verInativo = this.grid.checkFilterValue;
  }
  doChangeImage(event) {
    this.item.icon = event;
  }
}
